export { default } from './informationModal';
